import { apiClient } from './api';
import { Coupon } from '../types/coupons';
import { db } from './firebase';
import { collection, query, getDocs, doc, getDoc, orderBy, where } from 'firebase/firestore';

export const couponsService = {
    // 1. Lectura Directa: Reemplaza /listAllCoupons
    listAll: async (params: { status?: string; restaurantId?: string; limit?: number; offset?: number } = {}) => {
        try {
            let q = query(collection(db, 'coupons'), orderBy('createdAt', 'desc'));

            // Nota: Filtros simples se pueden aplicar aquí, pero por flexibilidad
            // (y falta de índices complejos) a veces es mejor filtrar en memoria si son pocos.
            if (params.restaurantId) {
                q = query(q, where('restaurantId', '==', params.restaurantId));
            }
            // Status filter can be applied here or in memory depending on index availability

            const snapshot = await getDocs(q);
            let coupons = snapshot.docs.map(doc => ({ couponId: doc.id, ...doc.data() } as any)) as Coupon[];

            // In-memory filtering for status if not indexed strictly
            if (params.status) {
                coupons = coupons.filter(c => c.status === params.status);
            }

            return { success: true, coupons, total: coupons.length };
        } catch (error) {
            console.error("Error listing coupons:", error);
            return { success: false, coupons: [], total: 0 };
        }
    },

    getById: async (couponId: string) => {
        // Lectura Directa: Reemplaza /admin/coupons/:id
        try {
            const docRef = doc(db, 'coupons', couponId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const coupon = { couponId: docSnap.id, ...docSnap.data() } as any as Coupon;
                return { success: true, coupon };
            }
            return { success: false, coupon: null as any };
        } catch (error) {
            console.error("Error getting coupon:", error);
            throw error;
        }
    },

    disable: async (couponId: string) => {
        // ESCRITURA: Mantiene la llamada al Backend (Seguridad)
        const response = await apiClient.patch<{ success: boolean; message: string }>(`/disableCoupon/${couponId}`, undefined, { params: { couponId } });
        return response.data;
    }
};
